import { takeLatest, put, call, select } from 'redux-saga/effects';
import { GET_DEPOSIT_BY_ID_SAGA } from "../sagaTypes";
import { loaderAction, setDepositFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { DEPOSIT_FORM_INITIAL } from "../initialStateConstant";

const request = data => {
    return fetch(`${ url }/get_deposit_by_id`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerGetDepositById(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('id', args.data.id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Открываем форму депозита
            yield put(setDepositFormAction({
                ...DEPOSIT_FORM_INITIAL,
                id: response.deposit.id,
                sum: response.deposit.sum,
                open: true
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherGetDepositById() {
    yield takeLatest(GET_DEPOSIT_BY_ID_SAGA, workerGetDepositById);
}